import React, { useEffect, useState } from 'react'
import * as QB from "quickblox/quickblox"
import "../../assets/scss/custom/inbox/DialogDetails.scss"
import { ReactComponent as PersonCircle } from "../../assets/images/inbox/person-circle.svg";
import { ReactComponent as PeopleFill } from "../../assets/images/inbox/people-fill.svg";
import { ReactComponent as PersonPlus } from "../../assets/images/inbox/person-plus.svg";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useDialogManager } from './helperHooks/HelperContext';
import SocialProfile from './SocialProfile';


export default function DialogIdetails({ selectedChat }) {
  const
    {
      createDialogModal, setCreateDialogModal,
      setDialogIdetailsArea,
      view, setView,
      userList,
      modifyDialogAttributes,
      occupantsList, setOccupantsList,
      userRole, setUserRole,
      dmOutsideExperienceSetup,
      setinvitePeopleStatus,
      existingChekedUser,
      getUserDetails,
      setnewInvitingPeople,
      getDialogProfileImage,
      setDialogDetails, dialogDetails,
      selectedMember,
      handleProfileClick,
      getdUserProfile

    } = useDialogManager();

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (selectedChat?.type !== 2) {
      setDialogIdetailsArea(false);
    }

    if (selectedChat) {
      getAdminUser(selectedChat?.user_id)
      setnewInvitingPeople(selectedChat?.occupants_ids)
    }
  }, [selectedChat])

  const getAdminUser = async (userId) => {
    const userDetails = await getUserDetails([userId])
    QB.getSession(function (error, session) {
      if (session?.session?.user_id === userId) {
        setUserRole({ role: "Admin", id: userId, name: userDetails?.data[0]?.display_name })
      } else {
        setUserRole({ role: "User", id: userId })
      }

    })
  }

  useEffect(() => {
    if (selectedChat?.type === 2 || selectedChat?.type === 3) {
      const occupantsArray = selectedChat?.occupants_ids;
      var searchParams = { filter: { field: 'id', param: 'in', value: occupantsArray }, page: 1, per_page: 100 };
      QB.users.listUsers(searchParams, function (error, result) {
        if (result) {
          setOccupantsList(result)
        }
        else {
          console.log("could find the users");
        }
      });
    }
  }, [selectedChat])


  return (
    <>
      {selectedMember ? <SocialProfile /> :
        <div className={`col-md-3 border-start bg-white shadow-sm slide-in `}>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-2">
            <h3 className="mb-0">Group Info</h3>
          </div>

          <div className="p-3 text-center">
            {selectedChat?.type === 3 ? (
              <PersonCircle width="70" height="70" fill="#75b35b" />
            ) : (
              <>{selectedChat?.photo && selectedChat.photo !== "null" ?
                <img className="bi bi-people-fill rounded-circle" width="70" height="70" src={getDialogProfileImage(selectedChat?.photo)} />
                :
                <PeopleFill width="70" height="70" fill="#75b35b" className="bi bi-people-fill" />}
              </>
            )}
            {/* Dialog Name */}
            <strong className="d-block mb-2">{ selectedChat?.experience_name ? selectedChat?.experience_name :  selectedChat?.name ? selectedChat?.name : "---"}</strong>
            <p className="post-description">{selectedChat?.subTitle ? selectedChat?.subTitle : "---"}</p>

            {(userRole?.role === "Admin" && selectedChat?.type === 2) &&
              <div className="d-flex justify-content-between align-items-center mb-3">
                <button
                  className="btn btn-sm btn-outline-success"
                  // style={{ border: "none" }}
                  onClick={() => {
                    setCreateDialogModal({ type: 2, visible: true });
                    setDialogDetails({ ...dialogDetails, dialogType: 5, });
                    setView({ buttonsArea: false, createGroupArea: true, userListArea: false })
                  }}
                >
                  Edit
                </button>

                <button
                  onClick={
                    () => {
                      setCreateDialogModal({ type: 2, visible: true })
                      dmOutsideExperienceSetup("Add Members");
                      setinvitePeopleStatus(true);
                      existingChekedUser();
                    }}
                  className="btn btn-sm btn-outline-success"
                >
                  Invite Members
                </button>
              </div>
            }

            {/* Accordion for Members */}
            {selectedChat?.type === 3 ? null :
              < div className="accordion" id="membersAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Members
                      <span className="badge bg-success ms-3 fs-6">
                        {selectedChat?.type === 2 ? occupantsList?.total_entries : occupantsList?.total_entries - 1}
                      </span>
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#membersAccordion"
                  >
                    <div className="accordion-body px-2">

                      {/* Search Bar */}
                      <input
                        type="text"
                        className="form-control mb-2 custom-input-focus"
                        placeholder="Search members..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />

                      {/* Scrollable List */}
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <ul className="list-group">
                          {occupantsList?.items
                            ?.filter(member =>
                              member?.user?.full_name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
                            )
                            .map((member, index) => {
                              const profileUrl = getdUserProfile({ external_id: member?.user?.external_user_id });
                              return (
                                <li
                                  key={index}
                                  className="list-group-item d-flex justify-content-between align-items-center mb-2"
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ flex: 1, minWidth: 0 }}
                                  >
                                    <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                                      {profileUrl ? (
                                        <img
                                          src={profileUrl}
                                          alt="Profile"
                                          width="25"
                                          height="25"
                                          className="rounded-circle me-2"
                                          style={{ objectFit: "cover" }}
                                          onClick={() => handleProfileClick(member)}
                                        />
                                      ) : (
                                        <PersonCircle
                                          width="25"
                                          height="25"
                                          fill="#75b35b"
                                          className="me-2 text-secondary flex-shrink-0"
                                          onClick={() => handleProfileClick(member)}
                                        />
                                      )}
                                      <span
                                        className="text-truncate"
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          textAlign: "left",
                                          flex: 1,
                                        }}
                                      >
                                        {member?.user?.full_name}
                                      </span>
                                    </div>

                                    {selectedChat?.user_id === member?.user?.id && (
                                      <strong style={{ fontWeight: "bold", marginLeft: "8px" }}>
                                        Group Admin
                                      </strong>
                                    )}
                                  </div>

                                  {/* Delete Button */}
                                  {userRole?.role === "Admin" &&
                                    selectedChat?.user_id !== member?.user?.id && (
                                      <button
                                        className="btn btn-sm btn-outline-danger ms-2 flex-shrink-0"
                                        style={{ border: "none" }}
                                        onClick={() =>
                                          modifyDialogAttributes({
                                            removedPersonId: [member?.user?.id],
                                            action: "pull_all",
                                            removedPersonName: member?.user?.full_name,
                                          })
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="12"
                                          height="12"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                      </button>
                                    )}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </>
  )
}
